import React from 'react';
import data from './footerObjects/footerLinks.json';

const UsefulLinks: React.FC = () => {
    return (
        <div className='text-white border-b-2 border-white md:border-none mb-6 pb-4 leading-8'>
            <h2 className='mb-4'>Useful Links</h2>
            <div className='flex flex-col'>
                {
                    data.links.map(link => (
                        <a className='text-white hover:font-bold' href={link.url}>{link.title}</a>
                    ))
                }
            </div>
        </div>
    )
}
export default UsefulLinks;
